if (!customElements.get('notify-me-form')) {
  class NotifyMeForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.emailInput = this.querySelector('input[name="email"]');
      this.variantIdInput = this.querySelector('.notify-me-form__variant-id');
      this.variantTitleInput = this.querySelector('.notify-me-form__variant-title');
      this.message = this.querySelector('.notify-me-form__message');
      this.submitButton = this.querySelector('.notify-me-form__submit');
      this.closeButton = this.querySelector('.notify-me-form__close');

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submitForm();
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }
    }

    setVariant(variantId, variantTitle) {
      if (this.variantIdInput) this.variantIdInput.value = variantId || '';
      if (this.variantTitleInput) this.variantTitleInput.value = variantTitle || '';
    }

    open() {
      this.hidden = false;
      this.classList.add('is-open');
      if (this.submitButton) this.submitButton.focus({ preventScroll: true });
    }

    close() {
      this.hidden = true;
      this.classList.remove('is-open');
    }

    showMessage(text, isError) {
      if (!this.message || !text) return;
      this.message.textContent = text;
      this.message.hidden = false;
      this.message.classList.toggle('is-error', !!isError);
    }

    submitForm() {
      if (this.submitButton && this.submitButton.classList.contains('loading')) return;

      const email = this.emailInput ? this.emailInput.value.trim() : '';
      if (!email) return;

      const endpoint = theme.routes.notify_me_api_endpoint;

      if (this.submitButton) this.submitButton.classList.add('loading');

      if (!endpoint) {
        this.showMessage(theme.strings.notifyMeUnavailable, true);
        if (this.submitButton) this.submitButton.classList.remove('loading');
        return;
      }

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          product_id: this.dataset.productId,
          variant_id: this.variantIdInput ? this.variantIdInput.value : '',
          variant_title: this.variantTitleInput ? this.variantTitleInput.value : '',
          product_url: window.location.href
        })
      })
        .then((response) => {
          if (!response.ok) throw new Error('notify-me-form-failed');
        })
        .then(() => {
          this.showMessage(theme.strings.notifyMeSuccess, false);
          this.form.reset();
        })
        .catch(() => {
          this.showMessage(theme.strings.notifyMeError, true);
        })
        .finally(() => {
          if (this.submitButton) this.submitButton.classList.remove('loading');
        });
    }
  }

  customElements.define('notify-me-form', NotifyMeForm);
}

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.notify-me');
  if (!trigger) return;

  e.preventDefault();

  const scope = trigger.closest('.product-form, .size_list__quick_buy__inner') || document;
  const notifyForm = scope.querySelector('notify-me-form') || document.querySelector('.product-form notify-me-form');

  if (!notifyForm) {
    window.location.href = theme.routes.storefront_login_url;
    return;
  }

  let variantId = trigger.dataset.variantId;
  let variantTitle = trigger.dataset.variantTitle;

  if (!variantId) {
    const selectedRadio = scope.querySelector('input[name="size_variant"]:checked');
    if (selectedRadio) {
      variantId = selectedRadio.dataset.valueId;
      variantTitle = selectedRadio.value;
    }
  }

  if (!variantId) {
    const hiddenIdInput = document.querySelector('input[name="id"]');
    if (hiddenIdInput) variantId = hiddenIdInput.value;
  }

  notifyForm.setVariant(variantId, variantTitle);
  notifyForm.open();
});
